<atomos-usp></atomos-usp>
<educational-excellance>
</educational-excellance>
<!-- <app-ai-powered-educational></app-ai-powered-educational> -->
<ai-powered-education-v2></ai-powered-education-v2>
<how-do-we-implement></how-do-we-implement>
<atomo-ai></atomo-ai>
<beneficiaries-partners></beneficiaries-partners>
<one-repository-unified-exp></one-repository-unified-exp>
<our-innovations></our-innovations>
<our-mission></our-mission>
<featured-on></featured-on>
<number-which-matter></number-which-matter>
<trusted-by-customers></trusted-by-customers>
<our-partner-foundries></our-partner-foundries>
<faq></faq>

<button class="waitlist" (click)="goToWaitlist()">
  Join our Waitlist
</button>
